export enum EditMode {
    ADD,
    VIEW,
    EDIT
}
